<template>
  <div class="highscores">
    <div class="container">
      <ResultCard
        v-for="(opponent, i) in opponents"
        :flipped="i % 2 !== 0"
        :opponent="opponent"
        :round="highScoresByOpponent[opponent.id]"
        :unlocked="opponentUnlockedStates[opponent.id]"
        :key="i"
      />
    </div>
  </div>
</template>

<script>
import { opponentIds, opponentsById } from '@/data/opponents'
import ResultCard from './partials/ResultCard/ResultCard'
import { mapGetters } from 'vuex'
export default {
  name: 'highscores',
  components: {
    ResultCard
  },
  computed: {
    opponents () {
      return opponentIds.map(id => opponentsById[id])
    },
    ...mapGetters('user', [
      'opponentUnlockedStates',
      'highScoresByOpponent'
    ])
  }
}
</script>

<style lang="scss" scoped>
.highscores {
  width: 100%;
  height: 100%;
  overflow: auto;
}
.container {
  display: flex;
  width: 100%;
  min-height: 100%;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  padding-top: calc(var(--spacing-1) + 1rem);
  > * { flex-shrink: 0 }
  @media #{$media-3} {
    max-width: 25rem;
    padding-top: 0;
    margin: auto;
  }
}
</style>
